<template>
  <svg
    class="edume-alert"
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m13.94 5.492 6.12 11.016C21.132 18.436 20.208 20 18 20H6c-2.21 0-3.13-1.566-2.06-3.492l6.12-11.016c1.072-1.929 2.81-1.926 3.88 0ZM12 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm0-8-.117.007a.999.999 0 0 0-.876.879L11 9.003v4.994c0 .525.386.94.883.996L12 15l.117-.007a.999.999 0 0 0 .876-.879l.007-.117V9.003A.994.994 0 0 0 12 8Z"
      fill="#5E5F61"
    />
  </svg>
</template>

<script>
export default {
  name: 'Alert',
};
</script>

<style scoped>
.edume-alert {
  padding-top: 4px;
}
</style>
